/* v8 ignore start */
// Actions
const HANDLE_OPEN = 'exampleWizards/simpleWizard/HANDLE_OPEN';
const HANDLE_CLOSE = 'exampleWizards/simpleWizard/HANDLE_CLOSE';

const initialState = () => ({
  isOpen: true,
  pages: []
});

// Reducer
const reducer = (state = initialState(), action = {}) => {
  const { type } = action;

  switch (type) {
    case HANDLE_OPEN:
      return initialState();
    case HANDLE_CLOSE:
      return { ...state, isOpen: false };
    default: return state;
  }
};

// Action Creators
const handleOpen = () => {
  return { type: HANDLE_OPEN };
};

const handleClose = () => {
  return { type: HANDLE_CLOSE };
};

export default reducer;
export {
  // Actions
  HANDLE_OPEN,
  HANDLE_CLOSE,
  // Action Creators
  handleOpen,
  handleClose,
};
